import React from 'react';
import type { TenantConfig } from '../config/tenants';

interface TenantLogoProps {
  tenant: TenantConfig;
  className?: string;
}

const TenantLogo: React.FC<TenantLogoProps> = ({
  tenant,
  className = 'h-[58px] w-[89px]',
}) => (
  <img
    alt={`${tenant.tenantName} Logo`}
    src={tenant.iconUrl}
    className={className}
  />
);

export default TenantLogo;
